<!-- Do not change this file. -->

<template>
  <div>
    <div class="container-fluid border-top py-2 text-small">
      <div class="d-flex justify-content-between" role="contentinfo">
        <div class="text-start my-auto">
          &copy; {{ year }} Oregon State University
        </div>

        <div class="text-end d-flex">
          <TheDebugger />
          <RouterLink
            :to="{ name: 'Participants' }"
            v-if="isAdmin"
            class="nav-link ms-3 my-auto text-primary"
            >Participants</RouterLink
          >
          <button
            class="btn btn-link m-0 p-0 my-auto ms-3"
            @click="toggleVersion"
          >
            {{ version }}
          </button>
          <a
            class="ms-3 my-auto"
            rel="noopener"
            target="_blank"
            href="https://main.oregonstate.edu/digital-millennium-copyright-act-contact-information"
            >Copyright</a
          >

          <a
            class="ms-3 my-auto"
            rel="noopener"
            target="_blank"
            href="https://oregonstate.edu/official-web-disclaimer"
            >Disclaimer</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Do not change this file. */
import TheDebugger from "@/components/debug/TheDebugger";
import { mapGetters } from "vuex";
import config from "@/data/config.json";

export default {
  name: "Footer",
  components: {
    TheDebugger
  },
  data: () => {
    return {
      publishYear: config.meta.publishedYear,
      showVersion: false
    };
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    year() {
      const currentYear = new Date().getFullYear(); // YYYY

      let yearString = "";
      /* Return just a single year */
      if (currentYear === this.publishYear) {
        yearString = `${currentYear}`;
      } else {
        /* Return a year range */
        yearString = `${this.publishYear} - ${currentYear}`;
      }

      return yearString;
    },
    version() {
      let version = "";

      if (this.showVersion) {
        version = document.lastModified;
      } else {
        version = require("./../../../package.json").version;
      }

      return version;
    }
  },
  methods: {
    toggleVersion() {
      this.showVersion = !this.showVersion;
    }
  }
};
</script>

<style scoped>
.text-small {
  font-size: 0.8em;
}

.btn {
  font-size: inherit;
}

a,
.btn {
  text-decoration: none;
}

a:hover,
.btn:hover {
  text-decoration: underline;
}
</style>
